import { Component, OnInit, Input } from '@angular/core';
import { MsgTemplateAutoMatch } from '../../msg-interface/msg-template-auto-match';
import { _MSGTYPES } from '../../shared/constant/msgType';

@Component({
  selector: 'app-tiktok-tpl-auto-match',
  templateUrl: './tiktok-tpl-auto-match.component.html',
  styles: [],
})
export class TiktokTplAutoMatchComponent implements OnInit, MsgTemplateAutoMatch {
  constructor() {}

  @Input() tplList: any[];
  viewList: any;
  type = _MSGTYPES.MT.TIKTOK.type;

  ngOnInit() {
    this.viewList = this.parseData();
  }

  /* 数据解析 */
  parseData() {
    return this.tplList;
  }
}
